import {AuthorizeHttpClientDecorator} from "../../decorators/authorize-http-client-decorator";
import {makeAuthDatasource} from "../datasources/auth-datasource-factory";
import {makeAxiosHttpClient} from "../http-client";

export const makeAuthorizeHttpClientDecorator = () => new AuthorizeHttpClientDecorator(
  makeAxiosHttpClient(),
  makeAuthDatasource()
)